import React, { Component } from "react";
import axios from "axios";
import isEmpty from "lodash/isEmpty";

import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from "../../../shared/vars";

// CSS
import "../../../css/display-table.css";

class LowInventory extends Component {
	constructor(props) {
		super(props);
		this.state = {
			dataLoaded: false,
			data: null,
			error: ""
		};
	}

	componentDidMount() {
		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + this.props.user.token };
		return axios
			.get(REACT_APP_API_URL + "summary/low-inventory", { headers: AUTH_HEADER })
			.then(response => {
				if (response.status !== 200) {
					this.setState({ dataLoaded: true, error: response.data.message });
				} else {
					this.setState({ dataLoaded: true, data: { ...response.data } });
				}
			})
			.catch(err => {
				this.setState({ dataLoaded: true, error: err.response.data.errors ? err.response.data.errors : err.response.data.message });
			});
	}

	render() {
		return (
			<div className="chart_area chart_1_2">
				{this.state.dataLoaded ? (
					<React.Fragment>
						<h2>Low Inventory</h2>
						{!isEmpty(this.state.data) ? (
							<table className="display_table light_table">
								<thead>
									<tr className="table-header">
										<th />
										<th>Sku</th>
										<th className="right_aligned">Inventory</th>
									</tr>
								</thead>
								<tbody>
									{Object.keys(this.state.data).map(key => (
										<tr key={key}>
											<td className="record-number">{1 + parseInt(key, 10)}</td>
											<td data-id="Sku">{this.state.data[key].sku}</td>
											<td data-id="Inventory" className="right_aligned">
												{this.state.data[key].inventory}
											</td>
										</tr>
									))}
								</tbody>
							</table>
						) : (
							<div>There are no low inventory products at this time!</div>
						)}
					</React.Fragment>
				) : null}
			</div>
		);
	}
}

export default LowInventory;



// WEBPACK FOOTER //
// ./src/components/admin/dashboard/LowInventory.js